import React from 'react'

import AddIcon from '@mui/icons-material/Add'
import { Box, Button } from '@mui/material'
import { formArray } from 'decorators'

import NameToDomainMapping from 'components/name-to-domain/NameToDomainMapping'

type NameToDomainMappingsProps = {
  field: {
    fields: {
      length: number
      push: (...args: any[]) => any
      remove: (...args: any[]) => any
      map: (fn: (memberName: string, index: number) => any) => any[]
    }
  }
  name: string
}

const NameToDomainMappings = ({ field }: NameToDomainMappingsProps) => {
  const handleAddNewRow = () => field.fields.push({ domain: '', name: {} })
  const handleRowRemove = (index: any) => () => field.fields.remove(index)

  return (
    <>
      {field.fields.map((_memberName, index) => (
        <NameToDomainMapping index={index} key={index} onRowRemove={handleRowRemove(index)} />
      ))}

      <Box sx={{ mt: '0.5rem' }}>
        <Button onClick={handleAddNewRow} variant="outlined">
          Add <AddIcon />
        </Button>
      </Box>
    </>
  )
}

export default formArray(NameToDomainMappings)
